import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { cx } from '@emotion/css';
import { ReactComponent as Exclamation } from '../../../../../assets/images/Exclamation.svg';
import { ReactComponent as QuestionMark } from '../../../../../assets/images/questionMark.svg';
import { InternalLinks } from '../../../../../constants';
import { useStyles } from './profile-link.styles';

interface DeactivationBannerProps {
  active?: boolean;
  dateOfDeactivation?: string;
}

export const DeactivationBanner = ({
  active,
  dateOfDeactivation,
}: DeactivationBannerProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.banner}>
      <div className={classes.bannerContent}>
        <Exclamation
          aria-hidden="true"
          className={cx(classes.bannerIcon, { [classes.bannerIconGrey]: !active })}
        />
        <div className={classes.bannerText}>
          {!active
            ? intl.formatMessage(
              { id: 'kidsProfile.alreadyEighteen' },
              {
                sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              },
            )
            : intl.formatMessage(
              { id: 'kidsProfile.turningEighteen' },
              {
                date: dateOfDeactivation,
                sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              },
            )}
        </div>
      </div>
      <Link to={InternalLinks.personalAccount} className={classes.bannerLink}>
        <QuestionMark aria-hidden="true" className={classes.helpIcon} />
        {intl.formatMessage({ id: 'kidsProfile.questionText' })}
      </Link>
    </div>
  );
};
